import useUserInfo from '../auth/useUserInfo';
import { useShallowSelector } from '../lib/reduxHooks';
import { UserOrigins } from '../lib/types';

export function useIsPrimeUser() {
  const userInfo = useUserInfo();
  const { settings, settingsFetched } = useShallowSelector((state) => ({
    settings: state.pageFrame.settings,
    settingsFetched: state.pageFrame.settingsFetched,
  }));

  if (!settingsFetched) return false;

  const isPrimeOrigin = settings?.account.userOrigin === UserOrigins.Prime;
  const isPrimeUser = isPrimeOrigin && userInfo?.isPrimeAuthenticated;
  return isPrimeUser;
}
